import { gql } from '@apollo/client';

import { User } from '@modules/user/user.model';
import { UserFragment } from '@modules/user/user.queries';

export const RequestAuthCodeMutation = gql`
  mutation requestAuthCode($emailOrPhone: String!, $retailerId: String!) {
    requestAuthCode(emailOrPhone: $emailOrPhone, retailerId: $retailerId) {
      message
    }
  }
`;

export type RequestAuthCodeMutationResult = {
  requestAuthCode: { message: string };
};

export const VerifyAuthCodeMutation = gql`
  mutation verifyAuthCode(
    $emailOrPhone: String!
    $code: String!
    $retailerId: String!
  ) {
    verifyAuthCode(
      emailOrPhone: $emailOrPhone
      code: $code
      retailerId: $retailerId
    ) {
      token
      user {
        ...UserFields
      }
    }
  }

  ${UserFragment}
`;

export type VerifyAuthCodeMutationResult = {
  verifyAuthCode: { token: string; user: User };
};

export const AuthUserViaQueryParamsMutation = gql`
  mutation authUserViaQueryParams($data: AuthQueryParamsInput!) {
    authUserViaQueryParams(data: $data) {
      token
      user {
        ...UserFields
      }
    }
  }

  ${UserFragment}
`;

export type AuthUserViaQueryParamsMutationResult = {
  authUserViaQueryParams: { token: string; user: User };
};

export const AuthGuestViaOrderLookupMutation = gql`
  mutation authGuestViaOrderLookup(
    $orderNumber: String!
    $contactDetails: String!
  ) {
    authGuestViaOrderLookup(
      orderNumber: $orderNumber
      contactDetails: $contactDetails
    ) {
      token
      user {
        ...UserFields
      }
    }
  }

  ${UserFragment}
`;

export type AuthGuestViaOrderLookupMutationResult = {
  authGuestViaOrderLookup: { token: string; user: User };
};

export const AuthGuestForReturnWithoutSalesOrderMutation = gql`
  mutation authGuestForReturnWithoutSalesOrder(
    $draftReturnId: String!
    $email: String!
  ) {
    authGuestForReturnWithoutSalesOrder(
      draftReturnId: $draftReturnId
      email: $email
    ) {
      token
      user {
        ...UserFields
      }
    }
  }

  ${UserFragment}
`;

export type AuthGuestForReturnWithoutSalesOrderMutationResult = {
  authGuestForReturnWithoutSalesOrder: { token: string; user: User };
};

export const decryptSearchOrderMutation = gql`
  mutation decryptSearchOrder($decryptionParams: DecryptionParamsInput) {
    decryptSearchOrder(decryptionParams: $decryptionParams) {
      email
    }
  }
`;

export type decryptSearchOrderResult = {
  decryptSearchOrder: {
    email: string;
  };
};
